// 首先导入基础工具类，不依赖其他模块
import { Storage } from './utils/storage'
import { Helper } from './utils/helper'

// 然后导入可能依赖于工具类的模块
import config from './config'
import { ErrorHandler } from './config'
import locale from './locale'
import i18n from './locale/i18n'
import pinia from './store/pinia'
import { initializeStores } from './store/pinia/stores'

// 最后导入可能依赖多个模块的组件
import wechat from './wechat'
import request from './request'
import { userRequest, systemRequest } from './request'

// 默认导出Vue插件
export default {
	install(app) {
		// 挂载到全局
		app.config.globalProperties.$http = request
		app.config.globalProperties.$userRequest = userRequest
		app.config.globalProperties.$systemRequest = systemRequest
		app.config.globalProperties.$storage = Storage
		app.config.globalProperties.$helper = Helper
		app.config.globalProperties.$locale = locale
		app.config.globalProperties.$wechat = wechat
		app.config.globalProperties.$stores = initializeStores()
		
		// 提供Composition API的组合式函数
		app.provide('http', request)
		app.provide('userRequest', userRequest)
		app.provide('systemRequest', systemRequest)
		app.provide('storage', Storage)
		app.provide('helper', Helper)
		app.provide('locale', locale)
		app.provide('wechat', wechat)
		app.provide('stores', initializeStores())
	}
}

// 导出工具方法供直接使用
export {
	Storage,
	Helper as helper,
	locale,
	wechat,
	pinia,
	i18n,
	config,
	ErrorHandler
}

// 导出所有请求实例和方法
export * from './request'

// 导出所有store
export * from './store/pinia'
